import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { IMG, DEFAULT_EVENT_GALLERY } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MediaContext = createContext({ slots: IMG, eventGallery: DEFAULT_EVENT_GALLERY });

export function resolveUrl(url) {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url; // frontend public asset (/events/..., /house/...)
}

export function MediaProvider({ children }) {
  const [media, setMedia] = useState({ slots: IMG, eventGallery: DEFAULT_EVENT_GALLERY });

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/site-media`)
      .then(({ data }) => {
        if (!active || !data) return;
        setMedia({
          slots: { ...IMG, ...(data.slots || {}) },
          eventGallery: data.event_gallery?.length ? data.event_gallery : DEFAULT_EVENT_GALLERY,
        });
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return <MediaContext.Provider value={media}>{children}</MediaContext.Provider>;
}

export const useMedia = () => useContext(MediaContext);
